export default "__VITE_ASSET__D9yk0$ss__"